import { createSelector } from 'reselect';
import { statsLeadersNavSelector } from '.';

/**
 * @returns {( object ) => object|null} Competition.
 */
export const competitionSelector = createSelector(
    statsLeadersNavSelector,
    ( state ) => state.competitions,
    ( nav, competitions ) => {
        try {
            return competitions[ `competition_${ nav.competition.id }` ];
        } catch ( err ) {
            return null;
        }
    }
);